import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import adImage from "../assets/easter-buffet.png";

export default function AdPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (imageLoaded) setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [imageLoaded]);

  useEffect(() => {
    const img = new Image();
    img.src = adImage;
    img.onload = () => setImageLoaded(true);
  }, []);

  if (!isVisible) return null;

  const handleBookNow = () => {
    setIsVisible(false);
    navigate("/easter-buffet");
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-2 py-3">
      <div className="relative flex max-h-[95vh] w-fit max-w-full flex-col items-center">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute -right-3 -top-3 z-20 flex h-9 w-9 items-center justify-center text-lg rounded-full bg-black text-white leading-none font-bold"
          aria-label="Close popup"
        >
          ×
        </button>

        <img
          src={adImage}
          alt="Mother's Day Promo"
          className="block max-h-[calc(95vh-96px)] w-auto max-w-full rounded-t-2xl"
        />

        <button
          onClick={handleBookNow}
          className="w-full rounded-b-2xl bg-red-600 px-4 py-2.5 text-base font-medium text-white transition hover:bg-red-700"
        >
          Click to Book
        </button>
      </div>
    </div>
  );
}
